// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@bg/App/Components/MyListDetails/CreateNewGroupModal";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.groupsWrapper = {
    css: css`
        ${styles.groupsWrapper?.css}
        align-items: flex-start;
    `,
};

styles.groupItem = {
    css: css`
        ${styles.groupItem?.css}
        &&& .item-wrapper span {
            color: ${getColor("text.main")};
            font-size: ${fontConfig.fontSize.small}px;
            line-height: 17px;
            letter-spacing: 1px;
            font-weight: ${fontConfig.weight.semiBold};
        }
    `,
};

styles.addNewButton = {
    variant: "secondary",
    css: css`
        ${styles.addNewButton?.css}
        &&& svg polygon {
            fill: ${getColor("text.main")};
        }
    `,
};

styles.addNewGroupItem = {
    css: css`
        ${styles.addNewGroupItem?.css}
        &&& + span {
            color: ${getColor("text.main")} !important;
            font-size: ${fontConfig.fontSize.small}px;
            line-height: 17px;
            letter-spacing: 1px;
            font-weight: ${fontConfig.weight.semiBold};
        }
    `,
};
